import { toast } from 'sonner'

export const notifications = {
  success: (title: string, message?: string) => {
    toast.success(title, {
      description: message,
      duration: 3000,
    })
  },

  error: (title: string, message?: string) => {
    toast.error(title, {
      description: message,
      duration: 4000,
    })
  },

  info: (title: string, message?: string) => {
    toast.info(title, {
      description: message,
      duration: 3000,
    })
  },

  warning: (title: string, message?: string) => {
    toast.warning(title, {
      description: message,
      duration: 3000,
    })
  },

  levelUp: (level: number) => {
    toast.success(`🎉 Level Up!`, {
      description: `You've reached Level ${level}! Keep crushing those quests!`,
      duration: 5000,
    })
  },

  focusComplete: (duration: number, xpReward: number) => {
    toast.success('🧘 Focus Session Complete!', {
      description: `You focused for ${duration} minutes and earned ${xpReward} XP!`,
      duration: 4000,
    })
  },

  welcomeEmail: (name: string, email: string) => {
    // Simulate email notification
    toast.success('📧 Welcome to QuestZen AI!', {
      description: `A welcome email has been sent to ${email}. Check your inbox to get started!`,
      duration: 5000,
    })

    // In production, this would trigger an actual email via backend
    console.log(`
      ===== WELCOME EMAIL =====
      To: ${email}
      Subject: Welcome to QuestZen AI - Turn Goals Into Focused Quests!
      
      Hi ${name},
      
      Welcome to QuestZen AI! We're excited to have you on board.
      
      Here's what you can do:
      • Create and track your quests with AI assistance
      • Use Focus Mode to eliminate distractions
      • Collaborate with friends on shared goals
      • Earn XP and level up
      • Compete on the leaderboard
      
      Ready to find your zen? Log in and create your first quest!
      
      Best regards,
      The QuestZen AI Team
      ========================
    `)
  },

  focusReminder: (duration: number) => {
    toast.info('⏰ Focus Session Starting', {
      description: `Your ${duration}-minute focus session is about to begin. Get ready!`,
      duration: 3000,
    })
  },

  focusBreak: () => {
    toast.success('☕ Time for a Break!', {
      description: 'Great work! Take a 5-minute break to recharge.',
      duration: 4000,
    })
  },

  questDueSoon: (questTitle: string, hoursLeft: number) => {
    toast.warning('⏰ Quest Due Soon', {
      description: `"${questTitle}" is due in ${hoursLeft} hours!`,
      duration: 4000,
    })
  },

  achievementUnlocked: (achievementName: string) => {
    toast.success('🏆 Achievement Unlocked!', {
      description: achievementName,
      duration: 5000,
    })
  },

  dailyStreak: (days: number) => {
    toast.success('🔥 Streak Maintained!', {
      description: `You're on a ${days}-day streak! Keep it up!`,
      duration: 4000,
    })
  },

  profileUpdated: () => {
    toast.success('✅ Profile Updated', {
      description: 'Your profile changes have been saved successfully.',
      duration: 3000,
    })
  },

  questCreated: () => {
    toast.success('🎯 Quest Created!', {
      description: 'Your new quest has been added to your list.',
      duration: 3000,
    })
  },

  questCompleted: (questTitle: string, xpEarned: number) => {
    toast.success('✅ Quest Completed!', {
      description: `"${questTitle}" - You earned ${xpEarned} XP!`,
      duration: 4000,
    })
  },

  questDeleted: () => {
    toast.info('🗑️ Quest Deleted', {
      description: 'The quest has been removed from your list.',
      duration: 3000,
    })
  },
}
